import { render, staticRenderFns } from "./Logistics.vue?vue&type=template&id=eb742636&"
import script from "./Logistics.vue?vue&type=script&lang=ts&"
export * from "./Logistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports